import { render, staticRenderFns } from "./footBar.vue?vue&type=template&id=09298eb8&scoped=true&"
var script = {}
import style0 from "./footBar.vue?vue&type=style&index=0&id=09298eb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09298eb8",
  null
  
)

export default component.exports